import { render, staticRenderFns } from "./Schedule.vue?vue&type=template&id=735f61a1&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/carolinethuelarsen/Documents/development/ibg-screen-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('735f61a1')) {
      api.createRecord('735f61a1', component.options)
    } else {
      api.reload('735f61a1', component.options)
    }
    module.hot.accept("./Schedule.vue?vue&type=template&id=735f61a1&", function () {
      api.rerender('735f61a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/views/schedule/Schedule.vue"
export default component.exports